// extracted by mini-css-extract-plugin
module.exports = {"root":"az_xI","disabled":"az_yI","input":"az_zI","checkmark-container":"az_AI","checkmark-border":"az_BI","checkmark-box":"az_CI","checkmark":"az_DI","label-text":"az_EI"};